function round(value,decimals) {  
  const precision = Math.pow(10,decimals);
  const a = parseFloat(value);  
  return Math.round(a*precision)/precision;
}

function redondear(num) {
  const float_value = parseFloat(num);//porque puede ser string
  return Math.round(float_value * 100) / 100;
}

export const mathUtils = {
  round,  
  redondear,
};
